<h1 mat-dialog-title>
  {{ (isEditMode ? 'advanceFilter.shiftDialog.editTitle' : 'advanceFilter.shiftDialog.addTitle') | translate }}
</h1>
<form #form="ngForm" [formGroup]="shiftFilterForm" (ngSubmit)="onFormDialogSubmit()">
  <div mat-dialog-content>
    <div class="shift-filter-dialog-section">
      <mat-button-toggle-group formControlName="mode" [hideSingleSelectionIndicator]="true">
        <mat-button-toggle value="currentShift">{{
          'advanceFilter.operator.$currentShift' | translate
        }}</mat-button-toggle>
        <mat-button-toggle value="previousShift">{{
          'advanceFilter.operator.$previousShift' | translate
        }}</mat-button-toggle>
        <mat-button-toggle value="other">{{ 'advanceFilter.shiftDialog.specific' | translate }}</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    @if (isOtherMode()) {
      <mat-dropdown
        [configurationInput]="shiftDropdownSettings"
        [options]="shiftDropdownOptions()"
        [formControl]="shiftFilterForm.controls.shiftIds"
        [isFormSubmitted]="form.submitted"
      >
      </mat-dropdown>
    } @else if (isShiftPhraseMode()) {
      <mat-dropdown
        [configurationInput]="lineDropdownSettings"
        [options]="lineDropdownOptions()"
        [formControl]="shiftFilterForm.controls.lineId"
        [isFormSubmitted]="form.submitted"
      >
      </mat-dropdown>

      <div class="shift-filter-dialog-section">
        <div class="shift-filter-dialog-label">{{ 'advanceFilter.shiftDialog.filtersToInclude' | translate }}</div>

        <div class="d-flex align-items-center justify-content-between gap-10">
          <div class="shift-filter-dialog-description">
            @if (filtersToIncludeSentence(); as sentence) {
              {{ sentence }}
            }
          </div>

          <button
            type="button"
            mat-icon-button
            [attr.aria-label]="'advanceFilter.shiftDialog.configureFiltersToInclude' | translate"
            (click)="toggleFiltersToIncludeConfig()"
          >
            <mat-icon>tune</mat-icon>
          </button>
        </div>

        @if (isFiltersToIncludeConfigVisible()) {
          <div class="d-flex flex-wrap gap-10">
            <mat-checkbox formControlName="includeDate">{{ 'advanceFilter.field.date' | translate }}</mat-checkbox>
            <mat-checkbox formControlName="includeShift">{{ 'advanceFilter.field.shiftId' | translate }}</mat-checkbox>
            <mat-checkbox formControlName="includeLine">{{ 'advanceFilter.field.lineId' | translate }}</mat-checkbox>
          </div>
        }

        @if (form.submitted && isNoFilterToAddSelected()) {
          <div class="shift-filter-dialog-error">
            {{ 'advanceFilter.shiftDialog.dateOrShiftRequired' | translate }}
          </div>
        }
      </div>
    }
  </div>

  <mat-dialog-actions align="end">
    <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
    <button mat-flat-button type="submit">
      {{ (isEditMode ? 'button.editFilter' : 'button.addFilter') | translate }}
    </button>
  </mat-dialog-actions>
</form>
